/* jshint esversion: 6 */
import { combineReducers, createStore, applyMiddleware } from 'redux';
import { combineEpics, createEpicMiddleware } from 'redux-observable';
import { app } from 'app/redux/reducers/app.js';
import { bootstrap } from 'app/redux/reducers/bootstrap.js';
import { bulk } from 'app/redux/reducers/bulk.js';
import { categories } from 'app/redux/reducers/categories.js';
import { connections } from 'app/redux/reducers/connections.js';
import { curation } from 'app/redux/reducers/curation.js';
import { domains } from 'app/redux/reducers/domains.js';
import { everqueue } from 'app/redux/reducers/everqueue.js';
import { feeds } from 'app/redux/reducers/feeds.js';
import { linkpages } from 'app/redux/reducers/linkpages.js';
import medic from 'app/redux/reducers/medicReducer.js';
import { modals } from 'app/redux/reducers/modals.js';
import { notifications } from 'app/redux/reducers/notifications.js';
import { plans } from 'app/redux/reducers/plans.js';
import { postgroups } from 'app/redux/reducers/postgroups.js';
import { posts } from 'app/redux/reducers/posts.js';
import { queue } from 'app/redux/reducers/queue.js';
import { automatedRoutes } from 'app/redux/reducers/routes.js';
import { shorteners } from 'app/redux/reducers/shorteners.js';
import { socials } from 'app/redux/reducers/socials.js';
import { socialLogins } from 'app/redux/reducers/socialLogins.js';
import { stats } from 'app/redux/reducers/stats.js';
import { subaccounts } from 'app/redux/reducers/subaccounts.js';
import { user } from 'app/redux/reducers/user.js';
import { utilities } from 'app/redux/reducers/utilities.js';
import * as appEpics from 'app/redux/epics/appEpics.js';
import * as bulkEpics from 'app/redux/epics/bulkEpics.js';
import * as categoryEpics from 'app/redux/epics/categoryEpics.js';
import * as connectionEpics from 'app/redux/epics/connectionEpics.js';
import * as curationEpics from 'app/redux/epics/curationEpics.js';
import * as domainEpics from 'app/redux/epics/domainEpics.js';
import * as everqueueEpics from 'app/redux/epics/everqueueEpics.js';
import * as feedEpics from 'app/redux/epics/feedEpics.js';
import * as inputEpics from 'app/redux/epics/inputEpics.js';
import * as linkpageEpics from 'app/redux/epics/linkpageEpics.js';
import * as medicEpics from 'app/redux/epics/medicEpics.js';
import * as notificationEpics from 'app/redux/epics/notificationEpics.js';
import * as outputEpics from 'app/redux/epics/outputEpics.js';
import * as planEpics from 'app/redux/epics/planEpics.js';
import * as postEpics from 'app/redux/epics/postEpics.js';
import * as postGroupEpics from 'app/redux/epics/postGroupEpics.js';
import * as queueEpics from 'app/redux/epics/queueEpics.js';
import * as routeEpics from 'app/redux/epics/routeEpics.js';
import * as shortenerEpics from 'app/redux/epics/shortenerEpics.js';
import * as socialEpics from 'app/redux/epics/socialEpics.js';
import * as socialLoginEpics from 'app/redux/epics/socialLoginEpics.js';
import * as statsEpics from 'app/redux/epics/statsEpics.js';
import * as subaccountEpics from 'app/redux/epics/subaccountEpics.js';
import * as userEpics from 'app/redux/epics/userEpics.js';
import * as utilityEpics from 'app/redux/epics/utilityEpics.js';

let rootReducer = combineReducers({
    app,
    bootstrap,
    bulk,
    automatedRoutes,
    categories,
    connections,
    curation,
    domains,
    everqueue,
    feeds,
    linkpages,
    medic,
    modals,
    notifications,
    plans,
    postgroups,
    posts,
    queue,
    shorteners,
    socials,
    socialLogins,
    stats,
    subaccounts,
    user,
    utilities
});

let rootEpic = combineEpics(
    ...Object.values(appEpics),
    ...Object.values(bulkEpics),
    ...Object.values(categoryEpics),
    ...Object.values(connectionEpics),
    ...Object.values(curationEpics),
    ...Object.values(domainEpics),
    ...Object.values(everqueueEpics),
    ...Object.values(feedEpics),
    ...Object.values(inputEpics),
    ...Object.values(linkpageEpics),
    ...Object.values(medicEpics),
    ...Object.values(notificationEpics),
    ...Object.values(outputEpics),
    ...Object.values(planEpics),
    ...Object.values(postEpics),
    ...Object.values(postGroupEpics),
    ...Object.values(queueEpics),
    ...Object.values(routeEpics),
    ...Object.values(shortenerEpics),
    ...Object.values(socialEpics),
    ...Object.values(socialLoginEpics),
    ...Object.values(statsEpics),
    ...Object.values(subaccountEpics),
    ...Object.values(userEpics),
    ...Object.values(utilityEpics)
);

const epicMiddleware = createEpicMiddleware();

let store = createStore(
    rootReducer,
    applyMiddleware(epicMiddleware)
);

epicMiddleware.run(rootEpic);

export {
    store as DlvrStore
};
